<template>
  <div class="list-table">
    <v-container>
      <v-layout row>
        <v-flex lg12>
          <v-card>
            <v-toolbar color="#E6C57D" dark>
              <v-toolbar-side-icon></v-toolbar-side-icon>
              <v-toolbar-title>Logs</v-toolbar-title>
            </v-toolbar>

            <v-list two-line v-if="logs.length > 0">
              <template v-for="(item, index) in logs">
                <v-list-tile :key="item.title" avatar ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      item.userComment
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      item.action
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-list-tile-action-text>{{
                      item.dateComment
                    }}</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  :key="index"
                  v-if="index + 1 < logs.length"
                ></v-divider>
              </template>
            </v-list>

            <v-list v-else>
              <template>
                <v-list-tile :key="1" avatar ripple>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Bienvenido al Sistema de Logs de TRANSIT
                    </v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                      >Aun no tiene logs.</v-list-tile-sub-title
                    >
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-list-tile-action-text>Ahora</v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { dateFormat } from '@/helpers/TransitHelper'
export default {
  data() {
    return {
      logs: [],
    }
  },
  methods: {
    dateFormat,
    getInvoiceId(invoiceId) {
      return Array.isArray(invoiceId) ? invoiceId.toString() : invoiceId
    },
  },
  created() {
    this.$store.dispatch('dashboard/getLogs').then(response => {
      if (response.data && response.data.logs) {
        this.logs = response.data.logs.reverse()
      }
    })
  },
}
</script>
